(function () {
  window.addEventListener("load", function () {
    const headerWrap = document.querySelector("#HeaderWrapper");
    const detailsEl = document.querySelectorAll(
      '[data-section-type="header"] details.has-megamenu[data-hover="true"]'
    );

    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "attributes") {
          if (mutation.attributeName === "open") {
            const currentState = mutation.target.getAttribute("open");
            if (currentState === null) {
              headerWrap.classList.remove("hover-mode");
            } else {
              headerWrap.classList.add("hover-mode");
            }
          }
        }
      }
    });

    detailsEl.forEach((detail) => {
      observer.observe(detail, { attributes: true });
    });

    let flktyEls = document.querySelectorAll("[data-flickity]");
    let flktyInstances = [];
    let lastWidth = window.innerWidth;

    function setFlickityInstances() {
      // Initialize Flickity for each carousel
      flktyEls = document.querySelectorAll("[data-flickity]");
      flktyEls.forEach(function (fe) {
        const flkty = Flickity.data(fe);
        flktyInstances.push(flkty);
      });
    }
    setFlickityInstances();

    function flktyResize() {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;

        if (flktyInstances.length == 0) {
          setFlickityInstances();
        }

        if (flktyInstances.length > 0) {
          const flktyViewports =
            document.querySelectorAll(".flickity-viewport");
          flktyViewports.forEach((fv) => {
            fv.parentNode.height = fv.style.height;
            fv.style.height = null;
            fv.classList.add("disable-transition");
          });

          window.setTimeout(() => {
            flktyInstances.forEach((f) => {
              f.resize();
            });

            window.setTimeout(() => {
              flktyViewports.forEach((fv) => {
                fv.parentNode.height = null;
                fv.classList.remove("disable-transition");
              });
            }, 40);
          }, 5);
        }
      }
    }

    function flktyRefresh() {
      flktyInstances.forEach((f) => {
        f.destroy();
      });

      flktyEls = document.querySelectorAll("[data-flickity]");
      flktyInstances = [];

      flktyEls.forEach((fe) => {
        let f;
        const flktyData = fe.getAttribute("data-flickity");
        if (flktyData) {
          const flktyOptions = JSON.parse(flktyData);
          f = new Flickity(fe, flktyOptions);
        } else {
          f = new Flickity(fe);
        }

        flktyInstances.push(f);
      });
    }

    const flktyResizeDebounce = window.theme.utils.debounce(150, () => {
      flktyResize();
    });

    window.addEventListener("resize", flktyResizeDebounce);

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", flktyRefresh);
    }
  });


  // NEW CODE
    // multi-ship
    const styleCont = document.querySelector('#multi-style-cont');
    const isMultiPage = window.location.pathname == '/a/gs/cart/' ? true : false;
    const isCartPage = window.location.pathname == '/cart' ? true : false;
    let firstRun = true;
    let cartInit = false;
    let gsInit = false;

    async function checkMultishipAvail(){
      const checkoutButton = document.querySelector('.btn.cart__checkout');
      if(checkoutButton){
        checkoutButton.disabled = true;
      }

      await fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          let hasSubscription = false;
          for(let i = 0; i < cart.items.length; i++){
            if(cart.items[i] && cart.items[i].hasOwnProperty('selling_plan_allocation')){
              hasSubscription = true;
              break;
            }
          }
          const toggleBox = document.querySelector('#gs__toggle-box');
          
          if(hasSubscription){
            // Clear Giftship multiship cookies
            document.cookie = "current_ms_state=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;";
            document.cookie = "gs_gistToken=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;";

            // Clear related localStorage keys
            // localStorage.removeItem("gs_saved_addresses");
            localStorage.removeItem("gs_cart_mode");
            localStorage.removeItem("gs_cart_state");
            localStorage.removeItem("gs_cart_product_ids");

            // Reset page-level state (if needed)
            if (typeof Gs !== "undefined" && Gs.options?.multishipping) {
                Gs.options.multishipping.enable = false;
            }
            
            if(toggleBox){
              const msCheckbox = document.querySelector('#gs__toggle-shipping');

              if(msCheckbox){
                if(msCheckbox.checked){
                  styleCont.innerHTML = '';

                  window.setTimeout(()=>{
                    msCheckbox.checked = false;
                    msCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
                    msCheckbox.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
                  }, 1);
                }
              }

              if(styleCont.innerHTML == ''){
                const styleTag = document.createElement('style');
                styleTag.textContent = '#gs__toggle-box { display: none !important; }';
                styleCont.appendChild(styleTag);
              }
            }

            if(checkoutButton){
              checkoutButton.removeAttribute('disabled');
            }
            
          }
          else if(toggleBox && styleCont && (isMultiPage || isCartPage)) {
            styleCont.innerHTML = '';
          }

          const multiShipLink = document.querySelector('.btn--multiship');
          if(multiShipLink){
            multiShipLink.style.display = hasSubscription ? 'none' : '';
          }

          // IMPORTANT: return the promise so the next .then waits
          return clearGiftshipAssignmentsFromItems(cart.items).then(() => cart);
        }).then(cart => {
          if(checkoutButton){
            checkoutButton.removeAttribute('disabled');
          }
        });
    }

    const isGiftshipProp = (key) =>
      key === 'Address' ||                // some installs add a visible Address property
      key === 'addr_index' ||             // seen in some setups
      key.startsWith('_gs');              // Giftship hidden props (_gs_*, _gsr, etc.)

    async function clearGiftshipAssignmentsFromItems(items) {
      const updates = [];

      for (const item of items) {
        const props = item.properties || {};
        const keys = Object.keys(props);
        if (!keys.length) continue;

        const hasGs = keys.some(isGiftshipProp);
        if (!hasGs) continue;

        const keep = {};
        for (const [k, v] of Object.entries(props)) {
          if (!isGiftshipProp(k)) keep[k] = v;
        }

        // Note: update this specific line by its `key`
        updates.push(fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, properties: keep })
        }));
      }

      if (updates.length) await Promise.all(updates);
    }

    function getGiftshipReady(){
      if(firstRun && gsInit && cartInit && !isMultiPage && !isCartPage){
        // NEW CODE
        let cbDefaultCheck = false;
        if (typeof(Gs) == 'object' && typeof(Gs.initializeDrawer) == 'function') {
          // Create a MutationObserver to watch for drawer content changes
          const gsContObserver = new MutationObserver((mutationsList, observerInstance) => {
            window.setTimeout(() => {
              const gsCheckbox = document.querySelector('input[name="attributes[gift]"]');
              const gsGiftMessage = document.querySelector('#gsMessage');

              if(gsCheckbox?.checked && !gsGiftMessage?.value){
                gsCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
                gsCheckbox.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
                gsCheckbox.checked = false;
                
                observerInstance.disconnect();
              }
            }, 5);
          });
          
          const gsAppCont = document.querySelector('#gsAppContainer'); 
          if (gsAppCont) {
            gsContObserver.observe(gsAppCont, {
              childList: true,
              subtree: true,
            });
          }

          Gs.initializeDrawer();
          firstRun = false;
        }
      }      
    }

    // window.addEventListener("load", function () {
    //   if (typeof(Gs) == 'object' && typeof(Gs.initializeDrawer) == 'function') {
    //     gsInit = true;
    //     getGiftshipReady();
    //   }
    //   else {
    //     window.setTimeout(() => {
    //       if (typeof(Gs) == 'object' && typeof(Gs.initializeDrawer) == 'function') {
    //         gsInit = true;
    //         getGiftshipReady();
    //       }
    //     }, 1500);
    //   }
    // });

    document.addEventListener('cart:bounded', () => {
      cartInit = true;
      getGiftshipReady();
    });

    document.addEventListener('cart:marked-up', () => {
      cartInit = true;
      (async () => {
        await checkMultishipAvail();
      })();
    });

    document.addEventListener('giftship.loaded', function() {
      gsInit = true;
      getGiftshipReady();

      (async () => {
        await checkMultishipAvail();
      })();
    });
})();
